import { services } from "../../../../api";
import { MedicalCalculatorItem } from "../../../../interfaces/api/congresses";

export const getMedicalCalculators = async (): Promise<MedicalCalculatorItem[]> => {
    try {
        const res = await services.congresses.getMedicalCalculators();
        if (res.result !== 'success') {
            throw new Error('error');
        }
        return res.content.data;
    } catch (ex) {
        return [];
    }
}